import React, { useEffect, useState } from "react";
import axiosInstance from "../utils/axiosInstance";

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TextField,
    IconButton
} from "@mui/material";

import { Delete, Add } from "@mui/icons-material";

const VariantComponentsModal = ({ open, variant, onClose }) => {

    const [components, setComponents] = useState([]);
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (!variant) return;

        loadData();
    }, [variant]);

    const loadData = async () => {
        const itemsRes = await axiosInstance.get("/product/items/simple");
        setItems(itemsRes.data || []);
        const compRes = await axiosInstance.get(`/product/variants/${variant.variant_id}/components`);
        setComponents(compRes.data || []);
    };

    const addRow = () => {
        setComponents([...components, {
            item_id: "",
            quantity: 1
        }]);
    };

    const update = (index, key, value) => {
        const copy = [...components];
        copy[index][key] = value;
        setComponents(copy);
    };

    const remove = (index) => {
        setComponents(components.filter((_, i) => i !== index));
    };

    const save = async () => {

        await axiosInstance.post(
            `/product/variants/${variant.variant_id}/components`,
            components
        );

        onClose();
    };

    return (
        <Dialog open={open} maxWidth="md" fullWidth>

            <DialogTitle>
                仕入商品の割り当て {variant?.sku}
            </DialogTitle>

            <DialogContent>

                <Table size="small">

                    <TableHead>
                        <TableRow>
                            <TableCell>商材</TableCell>
                            <TableCell width={120}>数量</TableCell>
                            <TableCell width={60}></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>

                        {components.map((c, i) => (

                            <TableRow key={i}>

                                <TableCell>

                                    <TextField
                                        select
                                        fullWidth
                                        value={c.item_id}
                                        onChange={(e) =>
                                            update(i, "item_id", e.target.value)
                                        }
                                        SelectProps={{ native: true }}
                                    >

                                        <option value=""></option>

                                        {items.map(item => (
                                            <option
                                                key={item.item_id}
                                                value={item.item_id}
                                            >
                                                {item.item_name}
                                            </option>
                                        ))}

                                    </TextField>

                                </TableCell>

                                <TableCell>

                                    <TextField
                                        type="number"
                                        value={c.quantity}
                                        onChange={(e) =>
                                            update(i, "quantity", e.target.value)
                                        }
                                    />

                                </TableCell>

                                <TableCell>

                                    <IconButton onClick={() => remove(i)}>
                                        <Delete />
                                    </IconButton>

                                </TableCell>

                            </TableRow>

                        ))}

                    </TableBody>

                </Table>

                <Button
                    startIcon={<Add />}
                    onClick={addRow}
                    sx={{ mt: 2 }}
                >
                    商材追加
                </Button>

            </DialogContent>

            <DialogActions>

                <Button onClick={onClose}>
                    キャンセル
                </Button>

                <Button
                    variant="contained"
                    onClick={save}
                >
                    保存
                </Button>

            </DialogActions>

        </Dialog>
    );
};

export default VariantComponentsModal;